var Backbone = require('backbone')
  , Overlay = require('mobile/ui/Overlay')

module.exports = function(tmpl) {

  return function(View, options) {
    options = options || {}

    return Backbone.View.extend({
      initialize: function(options) {
        this.overlay = new Overlay({ closable: true })
        this.view = new View(options)
        this.listenTo(this.view, 'close', this.close, this)
      }
    , events: {
        'click .overlay-close': 'handleCloseClicked'
      , 'click .btn-overlay-close': 'handleCloseClicked'
      }
    , handleCloseClicked: function(e) {
        e.preventDefault()
        this.close()
      }
    , open: function() {
        this.overlay.open()
      }
    , close: function() {
        this.overlay.close()
      }
    , render: function() {
        this.$el.html(tmpl())
        this.$('.view-placeholder')
          .replaceWith(this.view.render().el)

        this.overlay.setBody(this.$el)
        return this
      }
    })
  }

}
